export const isAccessRestricted = (error: unknown): boolean => {
    const e = error as any;
    const data = e?.response?.data ?? e?.data ?? e;
    return data?.error === 'AccessRestricted';
};